/**
 * ShopperSummary view.
 *
 *
 *
 */

var ShapewaysView = require('./ShapewaysView');

var ShopperSummary = ShapewaysView.extend({

  swAttrs: {
    title:            'data-sw-product-shopper-summary-title',
    description:      'data-sw-product-shopper-summary-description',
    piDescription:      'data-sw-product-shopper-summary-pi-description',
    firstToTryLabel:  'data-sw-product-shopper-summary-ftt'
  },

  swSelectors: {
    price:        '[data-sw-product-shopper-summary-price] [data-display-currency-component-value]'
  },

  initialize: function() {
    this.$title = this.$(this.swSelectors.title);
    this.$description = this.$(this.swSelectors.description);
    this.$piDescription = this.$(this.swSelectors.piDescription);
    // TODO: make CurrencyDisplay Component and remove [data-display-currency-component-value]
    this.$price = this.$(this.swSelectors.price);

    this.listenTo(this.model, 'change:currentConfigurationId', this.repaint, this);
  },

  render: function() {
    this.$title.html(this.model.get('shopperTitle'));
    this.$description.html(this.model.get('shopperDescription'));
    this.$price.html(this.model.get('shopperPrice'));

    var config = this.model.getCurrentProductConfiguration();
    if (config.firstToTry) {
      this.cachedElements.$firstToTryLabel.swShow();
    } else {
      this.cachedElements.$firstToTryLabel.swHide();
    }

    var currentProductItems = this.model.getCurrentConfiguredProductItems();
    var currentProductItem = currentProductItems[Object.keys(currentProductItems)[0]];
    this.$piDescription.html(currentProductItem.description);
  }

});

module.exports = ShopperSummary;
